module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.836acd10.svg";